import { Share2 } from "lucide-react";
import { ShareCardDialog, useShareCard } from "@/components/ShareCard";

export const ChamberShare = ({ liveId, chamber, i }) => {
  const s = useShareCard();
  return (<>
    <button type="button" disabled={s.busy} onClick={() => s.make({ kind: "results", live_id: liveId, chamber })} data-testid={`results-chamber-${i}-share`}
      className="inline-flex items-center gap-1 rounded-full border border-border px-2 py-0.5 text-[11px] font-medium text-slate-600 transition-colors hover:border-slate-400 disabled:opacity-50"><Share2 size={11} />Share</button>
    <ShareCardDialog card={s.card} title={`Election night: ${chamber}`} onClose={s.close} />
  </>);
};
